module.exports = __webpack_public_path__ + "media/images/scotch-aa0bb7b9.png";